__turbopack_context__.v({
  "enter": "modalHeader-module-scss-module__0DAIJq__enter",
  "exit": "modalHeader-module-scss-module__0DAIJq__exit",
  "fade-in": "modalHeader-module-scss-module__0DAIJq__fade-in",
  "fade-out": "modalHeader-module-scss-module__0DAIJq__fade-out",
  "fade-out-80": "modalHeader-module-scss-module__0DAIJq__fade-out-80",
  "header": "modalHeader-module-scss-module__0DAIJq__header",
  "right": "modalHeader-module-scss-module__0DAIJq__right",
  "slide-in-from-bottom": "modalHeader-module-scss-module__0DAIJq__slide-in-from-bottom",
  "slide-in-from-left": "modalHeader-module-scss-module__0DAIJq__slide-in-from-left",
  "slide-in-from-right": "modalHeader-module-scss-module__0DAIJq__slide-in-from-right",
  "slide-in-from-top": "modalHeader-module-scss-module__0DAIJq__slide-in-from-top",
  "slide-out-to-bottom": "modalHeader-module-scss-module__0DAIJq__slide-out-to-bottom",
  "slide-out-to-left": "modalHeader-module-scss-module__0DAIJq__slide-out-to-left",
  "slide-out-to-right": "modalHeader-module-scss-module__0DAIJq__slide-out-to-right",
  "slide-out-to-top": "modalHeader-module-scss-module__0DAIJq__slide-out-to-top",
  "title": "modalHeader-module-scss-module__0DAIJq__title",
  "zoom-in": "modalHeader-module-scss-module__0DAIJq__zoom-in",
  "zoom-out": "modalHeader-module-scss-module__0DAIJq__zoom-out",
});
